import { render, staticRenderFns } from "./OpdrItemsHeader.vue?vue&type=template&id=f3dd7b88&scoped=true&"
import script from "./OpdrItemsHeader.vue?vue&type=script&lang=js&"
export * from "./OpdrItemsHeader.vue?vue&type=script&lang=js&"
import style0 from "./OpdrItemsHeader.vue?vue&type=style&index=0&id=f3dd7b88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3dd7b88",
  null
  
)

export default component.exports